'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _debounce = require('debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var afterRender = (0, _debounce2.default)(function () {
	return window.nostojs && window.nostojs(function (api) {
		return api.loadRecommendations();
	});
}, 100); /** @jsx dom */


var render = function render(_ref) {
	var props = _ref.props;

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['CMS-Nosto', props.class, props.styleClasses.Nosto], 'data-style-attr': 'Nosto' },
		(0, _magicVirtualElement2.default)('div', { 'class': ['nosto_element', props.styleClasses.Element], 'data-style-attr': 'Element', id: props.nostoId.trim() })
	), props);
};

exports.default = { afterRender: afterRender, render: render };